import {Typography, Table} from "antd";
const { Text } = Typography;

function round2(n) {
  return Math.round((Number(n) + Number.EPSILON) * 100) / 100;
}

function computeTotals(lines = []) {
  let total = 0;
  let totalPermanente = 0;
  let totalAcompte = 0;

  for (const {
    location_ligne_montant,
    location_ligne_permanente,
    location_ligne_pourcentage_acompte,
    location_ligne_rubrique,
  } of lines) {
    const montant = parseFloat(location_ligne_montant) || 0;
    const signe = location_ligne_rubrique?.rubrique_signe;

    if (signe === "+") total += montant;
    else if (signe === "-") total -= montant;

    const acomptePart = montant * ((parseFloat(location_ligne_pourcentage_acompte) || 0) / 100);
    if (signe === "+") totalAcompte += acomptePart;
    else if (signe === "-") totalAcompte -= acomptePart;

    if (location_ligne_permanente) {
      if (signe === "+") totalPermanente += montant;
      else if (signe === "-") totalPermanente -= montant;
    }
  }

  const totalSolde = total - Math.round(totalAcompte); // tu faisais un Math.round ici
  return {
    total: round2(total),
    totalAcompte: Math.round(totalAcompte),
    totalSolde: round2(totalSolde),
    totalPermanente: round2(totalPermanente),
  };
}

export default function TableContrat({ location, home, components, columns }) {
  const lignes = location?.location_ligne || [];
  const { total, totalAcompte, totalPermanente } = computeTotals(lignes);

  return (
      <Table
        size={"middle"}
        dataSource={lignes}
        components={components}
        columns={columns}
        pagination={false}
        style={{ marginTop: 10, marginBottom: 10 }}
        locale={{ emptyText: "Aucune ligne" }}
        rowKey="location_ligne_id"
        summary={() => {
          return (
            <Table.Summary fixed>
              <Table.Summary.Row>
                {/* colonne 1 à 3 : cellules vides */}
                <Table.Summary.Cell index={0} colSpan={3}></Table.Summary.Cell>

                {/* Colonne 4 : TOTAL */}
                <Table.Summary.Cell index={3} align={"right"}>
                  <Text strong>TOTAL : </Text>
                  <Text>{total} €</Text>
                </Table.Summary.Cell>

                {/* Colonne 5 : vide */}
                <Table.Summary.Cell index={4}></Table.Summary.Cell>

                {/* Colonne 6 : ACOMPTE */}
                <Table.Summary.Cell index={5} align={"right"}>
                  <Text strong>ACOMPTE : </Text>
                  <Text>{totalAcompte} €</Text>
                </Table.Summary.Cell>

                {/* Colonne 7 : vide */}
                <Table.Summary.Cell index={6}></Table.Summary.Cell>

                {/* Colonne 8 : PERMANENT */}
                <Table.Summary.Cell index={7} align={"right"}>
                  <Text strong>PERMANENT : </Text>
                  <Text>{totalPermanente} €</Text>
                </Table.Summary.Cell>

                {/* Colonne 9 : vide */}
                <Table.Summary.Cell index={8} colSpan={2}></Table.Summary.Cell>
              </Table.Summary.Row>
            </Table.Summary>
          );
        }}
      />
  );
}
